import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/shared/auth/useAuth";
import { useDocumentTitle } from "@/shared/lib/useDocumentTitle";
import { Button } from "@/shared/ui/Button";
import { Notice } from "@/shared/ui/Notice";
import { RequireAuth } from "./RequireAuth";

function AdminsOnly() {
  const { t } = useTranslation("auth");
  const { signOut } = useAuth();
  useDocumentTitle(t("adminsOnly.title"));
  return (
    <div className="container" style={{ maxWidth: 560, paddingTop: "var(--space-7)" }}>
      <Notice tone="warn" title={t("adminsOnly.title")}>{t("adminsOnly.lead")}</Notice>
      <Button variant="ghost" onClick={() => void signOut()}>{t("adminsOnly.signOut")}</Button>
    </div>
  );
}

/** Every workshop page: signed-out visitors go to sign-in; a signed-in player who is not an admin is told so. */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { session } = useAuth();
  return <RequireAuth>{session?.role === "admin" ? children : <AdminsOnly />}</RequireAuth>;
}
